module.exports={render:function (){var _vm=this;
  return _vm._h('div', [_vm._m(0), " ", _vm._h('mt-loadmore', {
    ref: "loadmore",
    attrs: {
      "top-method": _vm.loadTop
    }
  }, [_vm._h('div', {
    staticClass: "main-page"
  }, [_vm._h('div', {
    staticClass: "favorite"
  }, [_vm._h('ul', {
    staticClass: "list-group-item large "
  }, [_vm._l((_vm.getMyContentListInfo.list), function(favorite) {
    return _vm._h('li', {
      staticClass: "list-group"
    }, [_vm._h('div', {
      staticClass: "liner"
    }), " ", _vm._h('router-link', {
      staticClass: "group-link clearfix",
      attrs: {
        "to": {
          'path': '/information/detail/' + favorite.contentId
        }
      }
    }, [_vm._h('img', {
      staticClass: "pull-right",
      attrs: {
        "src": favorite.contentImage ? (_vm.getMyContentListInfo.baseAcessPath + favorite.contentImage) : _vm.img_default,
        "width": "100",
        "height": "75"
      }
    }), " ", _vm._h('span', {
      staticClass: "block group-txt font-12"
    }, [_vm._h('span', {
      staticClass: "tit font-16"
    }, [_vm._s(favorite.contentTitle)]), " ", _vm._h('span', {
      staticClass: "data gray"
    }, [_vm._s(favorite.publishTimeString)])])])])
  })])])])])])
},staticRenderFns: [function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "topbar"
  }, [_vm._h('div', {
    staticClass: "clearfix main-wrap"
  }, [_vm._h('a', {
    staticClass: "pull-left img-back",
    attrs: {
      "href": "javascript:window.history.go(-1)"
    }
  }, ["返回"]), " ", _vm._h('h1', ["我的收藏"])]), " ", _vm._h('div', {
    staticClass: "liner"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.1@vue-loader/lib/template-compiler.js?id=data-v-6e4c68ee!./~/.10.0.1@vue-loader/lib/selector.js?type=template&index=0!./src/views/user/userCollection/CollectionList.vue
// module id = 212
// module chunks = 1